import { customRef, nextTick } from 'vue-demi';
import { useRoute, useRouter } from 'vue-router';
import { tryOnScopeDispose, toValue } from '@vueuse/shared';

var __defProp$2 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2 = (a, b) => __defProps$2(a, __getOwnPropDescs$2(b));
let _hash;
function useRouteHash(defaultValue, {
  mode = "replace",
  route = useRoute(),
  router = useRouter()
} = {}) {
  _hash = route.hash;
  tryOnScopeDispose(() => {
    _hash = void 0;
  });
  return customRef((track, trigger) => ({
    get() {
      track();
      return _hash || defaultValue;
    },
    set(v) {
      _hash = v === null ? void 0 : v;
      trigger();
      nextTick(() => {
        router[toValue(mode)](__spreadProps$2(__spreadValues$2({}, route), { hash: _hash }));
      });
    }
  }));
}

var __defProp$1 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
const _cache$1 = /* @__PURE__ */ new WeakMap();
function useRouteParams(name, defaultValue, options = {}) {
  const {
    mode = "replace",
    route = useRoute(),
    router = useRouter(),
    transform = (value) => value
  } = options;
  if (!_cache$1.has(route))
    _cache$1.set(route, /* @__PURE__ */ new Map());
  const _params = _cache$1.get(route);
  tryOnScopeDispose(() => {
    _params.delete(name);
  });
  _params.set(name, route.params[name]);
  return customRef((track, trigger) => ({
    get() {
      var _a;
      track();
      const data = (_a = _params.get(name)) != null ? _a : defaultValue;
      return transform(data);
    },
    set(v) {
      _params.set(name, v === defaultValue || v === null ? void 0 : v);
      trigger();
      nextTick(() => {
        router[toValue(mode)](__spreadProps$1(__spreadValues$1({}, route), { params: __spreadValues$1(__spreadValues$1({}, route.params), Object.fromEntries(_params.entries())) }));
      });
    }
  }));
}

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const _cache = /* @__PURE__ */ new WeakMap();
function useRouteQuery(name, defaultValue, options = {}) {
  const {
    mode = "replace",
    route = useRoute(),
    router = useRouter(),
    transform = (value) => value
  } = options;
  if (!_cache.has(route))
    _cache.set(route, /* @__PURE__ */ new Map());
  const _query = _cache.get(route);
  tryOnScopeDispose(() => {
    _query.delete(name);
  });
  _query.set(name, route.query[name]);
  return customRef((track, trigger) => ({
    get() {
      var _a;
      track();
      const data = (_a = _query.get(name)) != null ? _a : defaultValue;
      return transform(data);
    },
    set(v) {
      _query.set(name, v === defaultValue || v === null ? void 0 : v);
      trigger();
      nextTick(() => {
        router[toValue(mode)](__spreadProps(__spreadValues({}, route), {
          query: __spreadValues(__spreadValues({}, route.query), Object.fromEntries(_query.entries()))
        }));
      });
    }
  }));
}

export { useRouteHash, useRouteParams, useRouteQuery };
